<script setup lang="ts">
import Card from 'primevue/card';
import Message from 'primevue/message';
import KpButton from '@/components/KpButton.vue';
import KpPasswordField from '@/components/KpPasswordField.vue';
import Divider from 'primevue/divider';
import { computed, reactive } from 'vue';
import { createValidator, createValidators } from '@/helpers/model_validators';
import { formValidators } from '@/helpers/forms';
import { getI18n } from '@/helpers/i18n';

defineProps({
    footerText: {
        type: String,
        default: '',
    },
    error: {
        type: String,
        default: '',
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

defineEmits(['changePassword']);

const state = reactive({
    new_password_1: '',
    new_password_2: '',
});

const { validators } = createValidators({
    pw_complexity: createValidator(
        computed(() => state.new_password_1),
        [formValidators.passwordComplexity],
    ),
    same_pw: createValidator(
        computed(() => state.new_password_1 === state.new_password_2),
        [(val: boolean) => (val ? true : getI18n().t('keine_uebereinstimmung'))],
    ),
});
</script>

<template>
    <Card class="mt-5rem" style="width: 25rem; overflow: hidden; margin-left: auto; margin-right: auto">
        <template #title>ECO<sub>2</sub>Stat: {{ $t('anmelden') }}</template>
        <template #content>
            <Message severity="info">{{ $t('passwort_aendern_noetig') }}</Message>
            <KpPasswordField
                class="mt-2rem"
                fluid
                :label="$t('passwort')"
                placeholder="z.B. xYz91D(1/"
                show-error-placeholder
                v-model="state.new_password_1"
                :invalid="!validators.pw_complexity.isValid.value"
                :error="validators.pw_complexity.msg.value"
                @enter="$emit('changePassword', state)"
            >
                <template #footer>
                    <Divider></Divider>
                    <p>Mind. 8 Buchstaben</p>
                    <p>Mind. 1 Grossbuchstabe</p>
                    <p>Mind. 1 Kleinbuchstabe</p>
                    <p>Mind. 1 Zahl</p>
                </template>
            </KpPasswordField>
            <KpPasswordField
                fluid
                :label="$t('passwort_wiederholen')"
                :feedback="false"
                :invalid="!validators.same_pw.isValid.value"
                :error="validators.same_pw.msg.value"
                show-error-placeholder
                v-model="state.new_password_2"
                @enter="$emit('changePassword', state)"
            />
        </template>
        <template #footer>
            <div class="flex gap-4 mt-1">
                <KpButton
                    :disabled="!state.new_password_1 || !state.new_password_2"
                    :label="$t('passwort_aendern')"
                    class="w-full"
                    icon="far fa-right-to-bracket"
                    iconPos="right"
                    :loading="loading"
                    @click="$emit('changePassword', state)"
                />
            </div>
            <Message v-if="error" severity="error" class="w-full my-1rem">{{ error }}</Message>
            <div class="w-full mt-2rem text-center" v-html="footerText"></div>
        </template>
    </Card>
</template>
